import { useState } from 'react';
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ErrorMessage from '@/components/errorMessage';
import SettingCondition from './settingCondition';

type Props = {
  conditions: any[];
  settingNames: any[];
  maxHeight?: number;
  onAddCondition: (condition: any) => void;
  onDeleteCondition: (condition: any) => void;
};

const SettingConditions = ({ conditions = [], settingNames = [], onAddCondition, onDeleteCondition }: Props) => {
  const [newCondition, setNewCondition] = useState(false);
  const [newConditionError, setNewConditionError] = useState('');

  const addNewCondition = () => {
    setNewConditionError('');
    setNewCondition(true);
  };

  const addCondition = (condition: any) => {
    onAddCondition(condition);
    setNewCondition(false);
    setNewConditionError('');
  };

  const cancelAdd = () => {
    setNewConditionError('');
    setNewCondition(false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: 1,
        borderColor: 'divider',
        borderRadius: '12px',
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: 2, py: 1, borderBottom: 1, borderColor: 'divider', bgcolor: 'rgba(0,0,0,0.02)' }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Conditions
        </Typography>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          onClick={() => addNewCondition()}
          disabled={newCondition}
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: '8px', boxShadow: 'none' }}
        >
          Add Condition
        </Button>
      </Stack>

      <Box sx={{ flex: 1, overflow: 'auto', p: 1, minHeight: 150, maxHeight: 300 }}>
        {newConditionError && <ErrorMessage error={{ message: newConditionError }} />}
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Setting Name
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Setting Value
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {newCondition && (
                <SettingCondition
                  settingNames={settingNames}
                  onAdd={addCondition}
                  onDelete={onDeleteCondition}
                  onCancelAdd={cancelAdd}
                />
              )}
              {(conditions || []).map((condition: any, idx: any) => (
                <SettingCondition
                  key={idx}
                  settingNames={settingNames}
                  condition={condition}
                  onAdd={addCondition}
                  onDelete={onDeleteCondition}
                  onCancelAdd={cancelAdd}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default SettingConditions;
